/**
 * AI Report Summary Sagas
 * 
 * This file contains saga watchers and workers for AI report summary actions.
 */

import { takeLatest, call, put } from 'redux-saga/effects';
import * as actionTypes from '../actions/actionTypes';
import AIApi from '../api/AIApi';

/**
 * Worker saga for fetching AI insights
 * 
 * @param {Object} action - The action object
 */
function* fetchAIInsightsSaga(action) {
  try {
    yield put({ type: actionTypes.FETCH_AI_SUMMARY_LOADING });
    
    const { eventId, modelId, forceRefresh, isSummaryView, questionNumber } = action.payload || {};
    console.log('Fetching AI insights with:', { eventId, modelId, forceRefresh, isSummaryView, questionNumber });
    
    const summary = yield call(AIApi.getEventSummary, eventId, modelId, forceRefresh, isSummaryView, questionNumber);
    
    yield put({
      type: actionTypes.FETCH_AI_SUMMARY_SUCCESS,
      summary
    });
  } catch (error) {
    yield put({
      type: actionTypes.FETCH_AI_SUMMARY_ERROR,
      error: error.message || 'Failed to fetch AI insights'
    });
  } finally {
    yield put({ type: actionTypes.FETCH_AI_SUMMARY_DONE });
  }
}

/**
 * Worker saga for generating AI insights
 * 
 * @param {Object} action - The action object
 */
function* generateAIInsightsSaga(action) {
  try {
    yield put({ type: actionTypes.GENERATE_AI_SUMMARY_LOADING });
    
    const { eventId, modelId } = action.payload || {};
    const summary = yield call(AIApi.generateEventSummary, eventId, modelId);
    
    yield put({
      type: actionTypes.GENERATE_AI_SUMMARY_SUCCESS,
      summary
    });
  } catch (error) {
    yield put({
      type: actionTypes.GENERATE_AI_SUMMARY_ERROR,
      error: error.message || 'Failed to generate AI insights'
    });
  } finally {
    yield put({ type: actionTypes.GENERATE_AI_SUMMARY_DONE });
  }
}

/**
 * Worker saga for fetching AI models
 */
function* fetchAIModelsSaga() {
  try {
    yield put({ type: actionTypes.FETCH_AI_MODELS_LOADING });
    
    const models = yield call(AIApi.getAvailableModels);
    
    yield put({
      type: actionTypes.FETCH_AI_MODELS_SUCCESS,
      models
    });
  } catch (error) {
    yield put({
      type: actionTypes.FETCH_AI_MODELS_ERROR,
      error: error.message || 'Failed to fetch available AI models'
    });
  } finally {
    yield put({ type: actionTypes.FETCH_AI_MODELS_DONE });
  }
}

// Watcher sagas
const aiReportSummarySagas = [
  takeLatest(actionTypes.FETCH_AI_SUMMARY, fetchAIInsightsSaga),
  takeLatest(actionTypes.GENERATE_AI_SUMMARY, generateAIInsightsSaga),
  takeLatest(actionTypes.FETCH_AI_MODELS, fetchAIModelsSaga)
];

export default aiReportSummarySagas;
